export const printT = {
  fr: {
    barTitle: "Plan d'Affaires EcoLunch",
    download: 'Télécharger PDF',
    back: 'Retour au plan',
    coverTitle: "Plan d'Affaires EcoLunch",
    coverSub: 'Plateforme SaaS + FinTech pour la gestion des repas scolaires',
    coverMeta: '10 Provinces canadiennes | Pre-seed 500K | Horizon 12 mois (Y1)',
    rev5: 'Revenus 5 ans', baiia5: 'BAIIA 5 ans', gmv5: 'GMV 5 ans',
    toc: 'Table des matieres',
    tocItems: ['Introduction', 'Marche et Opportunite', 'Vision et Objectifs', 'Produit et Experience', 'Propriete Intellectuelle', 'Paiements, Securite et Architecture', "Plan d'Execution", 'Go-to-Market (GTM)', 'Roadmap et Jalons', 'Resume Executif', "Modele d'Affaires", 'Organisation et Couts', 'Valorisation', 'Synthese Investisseur', 'Previsions Financieres Y1 (12 mois)'],
    s1: '1. Introduction',
    s1p: "EcoLunch est la premiere plateforme unifiee SaaS + FinTech qui standardise la gestion des repas scolaires au Canada. Elle connecte parents, ecoles, traiteurs et Centres de Services Scolaires (CSS) en un seul ecosysteme numerique : commande, paiement, production, rapports, gouvernance, satisfaction et securite des donnees.",
    propVal: 'Proposition de valeur',
    propRows: [
      ['SaaS Multi-acteurs', "Plateforme operationnelle pour tous les intervenants de l'ecosysteme scolaire"],
      ['FinTech Integree', 'Paiements securises, fractionnement Sezzle (BNPL), abonnements parents'],
      ['100% Quebec', 'Hebergement et paiements via SonaPay, serveurs au Quebec'],
      ['Rentable rapidement', 'Le modele devient rentable des que le taux de participation depasse ~15%, avec un scenario central deja positif dans une structure lean.'],
    ],
    keyMetrics: 'Metriques cles (5 ans)',
    metric: 'Metrique', value: 'Valeur',
    metRows: ['Ecoles visees', 'Provinces', 'Revenus 5 ans', 'BAIIA 5 ans', 'GMV 5 ans', 'Marge BAIIA'],
    s2: '2. Marche et Opportunite',
    tam: 'Marches Totaux Adressables (TAM) - 10 Provinces',
    province: 'Province', totalSchools: 'Ecoles totales', public: 'Public', private: 'Prive', targetY5: 'Objectif Y5', penetration: 'Penetration',
    totalCanada: 'TOTAL CANADA',
    expSeq: "Sequence d'expansion",
    year: 'Annee', provinces: 'Provinces', newEntries: 'Nouvelles entrees',
    launch: 'Lancement',
    pains: 'Douleurs Identifiees',
    painItems: ['Fragmentation des systemes', 'UX datee et complexe', 'Double saisie des donnees', 'Faible gouvernance/qualite', 'Manque de rapports automatises', 'Processus manuels inefficaces'],
    oppo: 'Opportunite',
    oppoText: "Marche sous-digitalise avec forte demande. <strong>Aucun leader dominant</strong> dans l'espace SaaS + FinTech pour repas scolaires au Canada. TAM de 12 705 ecoles.",
    s3: '3. Vision et Objectifs',
    vision: 'Notre Vision',
    visionText: "Transformer durablement l'alimentation scolaire et faire d'EcoLunch la <strong>norme numerique officielle</strong> dans les 10 provinces canadiennes.",
    baseAssumptions: 'Hypotheses de base',
    partRate: 'Taux de participation evolutif',
    partCap: 'Plafond realiste : 30%. La participation croit avec la maturite du marche et l\'habitude des parents.',
    avgPrice: 'Prix moyen du repas',
    expSchools: 'Expansion ecoles par province',
    s4: '4. Produit et Experience',
    feats: [
      { cat: 'Parent/Enfant', items: ['Commande en 15 secondes', 'Rappels automatiques', 'Co-parentalite (permissions, split)', 'Mode enfant (Avatars, Badges, Recompenses, Gamification)'] },
      { cat: 'Traiteur', items: ['Back-office complet', 'Gestion automatisee', 'Gestion menus et production', 'Integration API (Comptabilite, Production, Communications)'] },
      { cat: 'Ecole', items: ['Portail quotidien temps reel', 'Suivi de satisfaction', 'Alertes intelligentes', 'Rapports automatises'] },
      { cat: 'Direction/CSS', items: ['Portefeuille multi-etablissements', 'Comparatifs et benchmarks', 'Politiques et standards', 'Escalades et audit trail'] },
    ],
    messaging: 'Messagerie Interne Unifiee',
    messagingText: 'Communication securisee multi-niveaux avec RBAC hierarchique adaptatif et permissions configurables.',
    s5: '5. Propriete Intellectuelle Integree',
    s5intro: "EcoLunch repose sur une plateforme operationnelle critique sectorielle, propriete intellectuelle integree, systemique et transversale, developpee entierement a l'interne et detenue a 100% par la societe.",
    piVal: 'Valuation de la PI',
    reconCost: 'Cout de reconstruction', defValue: 'Valeur de marche defendable',
    piComponents: 'Composantes — EcoTechSysteme',
    module: 'Module', description: 'Description', time: 'Temps', cost: 'Cout',
    infraNote: 'Infrastructure, securite, DevOps, QA, documentation',
    s6: '6. Paiements, Securite et Architecture',
    payStruct: 'Structure des Paiements',
    source: 'Source',
    secTitle: 'Securite',
    secItems: ['Multi-tenant isole (RBAC)', 'Chiffrement end-to-end', 'WAF/DDoS protection', 'Conformite LPRPDE/PIPEDA et Loi 25', 'Donnees hebergees au Quebec'],
    s7: "7. Plan d'Execution",
    period: 'Periode', objective: 'Objectif',
    s8: '8. Go-to-Market (GTM)',
    catalyst: 'Catalyseur : Reseau CSS et School Boards',
    catalystText: "Acces direct aux 61 CSS du Quebec + 380 districts canadiens. La signature d'une seule entite institutionnelle donne acces a de multiples ecoles simultanement.",
    ratioTitle: 'Ratio ecoles/traiteur evolutif',
    phase: 'Phase', catererType: 'Type traiteurs', ratio: 'Ratio', caterers: 'Traiteurs',
    acqStrategy: "Strategie d'Acquisition",
    acqItems: ['Vente directe B2B via vendeurs terrain (contractuels)', 'Partenariats CSS multi-ecoles', 'SaaS gratuit pour les 22 premiers traiteurs (incentive de lancement)', "Enveloppe de 50 000$ pour incitatifs de conversion (aide a la migration)"],
    s9: '9. Roadmap et Jalons',
    highlights: 'Points cles',
    s10: '10. Resume Executif',
    s11: "11. Modele d'Affaires",
    revStreams: 'Flux de revenus',
    revType: 'Type', revDetail: 'Detail',
    s12: '12. Organisation et Couts',
    opex: 'OPEX annuel',
    role: 'Poste', y1: 'Y1', y2: 'Y2', y3: 'Y3', y4: 'Y4', y5: 'Y5',
    prelaunch: 'Pre-lancement (250 000$)',
    opex6m: 'OPEX pre-launch (6 mois x 20 000$/mois)',
    incentives: 'Incitatifs conversion traiteurs',
    reserve: 'Reserve / marge de securite',
    totalPrelaunch: 'Total pre-launch',
    s13: '13. Valorisation',
    multiples: 'Multiples',
    multiple: 'Multiple', valuation: 'Valorisation',
    s14: '14. Synthese Investisseur',
    s15: '15. Previsions Financieres Y1 (12 mois)',
    revLabel: 'Revenus', baiiaLabel: 'BAIIA', margin: 'Marge',
    disclaimer: 'Document confidentiel — EcoTech Solutions Inc. — {year}',
  },
  en: {
    barTitle: 'EcoLunch Business Plan',
    download: 'Download PDF',
    back: 'Back to plan',
    coverTitle: 'EcoLunch Business Plan',
    coverSub: 'SaaS + FinTech platform for school meal management',
    coverMeta: '10 Canadian Provinces | Pre-seed 500K | 60-month horizon',
    rev5: '5-year Revenue', baiia5: '5-year EBITDA', gmv5: '5-year GMV',
    toc: 'Table of Contents',
    tocItems: ['Introduction', 'Market & Opportunity', 'Vision & Objectives', 'Product & Experience', 'Intellectual Property', 'Payments, Security & Architecture', 'Execution Plan', 'Go-to-Market (GTM)', 'Roadmap & Milestones', 'Executive Summary', 'Business Model', 'Organization & Costs', 'Valuation', 'Investor Summary', 'Financial Projections Y1 (12 months)'],
    s1: '1. Introduction',
    s1p: "EcoLunch is the first unified SaaS + FinTech platform that standardizes school meal management across Canada. It connects parents, schools, caterers and School Boards (CSS) in a single digital ecosystem: ordering, payment, production, reporting, governance, satisfaction and data security.",
    propVal: 'Value Proposition',
    propRows: [
      ['Multi-stakeholder SaaS', 'Operational platform for all school ecosystem stakeholders'],
      ['Integrated FinTech', 'Secure payments, Sezzle installments (BNPL), parent subscriptions'],
      ['100% Quebec', 'Hosting and payments via SonaPay, servers in Quebec'],
      ['Quickly Profitable', 'The model becomes profitable once participation exceeds ~15%, with the central scenario already positive in a lean structure.'],
    ],
    keyMetrics: 'Key Metrics (5 years)',
    metric: 'Metric', value: 'Value',
    metRows: ['Target schools', 'Provinces', '5-year Revenue', '5-year EBITDA', '5-year GMV', 'EBITDA Margin'],
    s2: '2. Market & Opportunity',
    tam: 'Total Addressable Markets (TAM) - 10 Provinces',
    province: 'Province', totalSchools: 'Total Schools', public: 'Public', private: 'Private', targetY5: 'Y5 Target', penetration: 'Penetration',
    totalCanada: 'TOTAL CANADA',
    expSeq: 'Expansion Sequence',
    year: 'Year', provinces: 'Provinces', newEntries: 'New entries',
    launch: 'Launch',
    pains: 'Identified Pain Points',
    painItems: ['System fragmentation', 'Dated & complex UX', 'Double data entry', 'Weak governance/quality', 'Lack of automated reporting', 'Inefficient manual processes'],
    oppo: 'Opportunity',
    oppoText: "Under-digitized market with strong demand. <strong>No dominant leader</strong> in the SaaS + FinTech space for school meals in Canada. TAM of 12,705 schools.",
    s3: '3. Vision & Objectives',
    vision: 'Our Vision',
    visionText: "Sustainably transform school food and make EcoLunch the <strong>official digital standard</strong> across all 10 Canadian provinces.",
    baseAssumptions: 'Base Assumptions',
    partRate: 'Evolving Participation Rate',
    partCap: 'Realistic cap: 30%. Participation grows with market maturity and parent habits.',
    avgPrice: 'Average Meal Price',
    expSchools: 'School Expansion by Province',
    s4: '4. Product & Experience',
    feats: [
      { cat: 'Parent/Child', items: ['Order in 15 seconds', 'Automatic reminders', 'Co-parenting (permissions, split)', 'Child mode (Avatars, Badges, Rewards, Gamification)'] },
      { cat: 'Caterer', items: ['Complete back-office', 'Automated management', 'Menu & production management', 'API Integration (Accounting, Production, Communications)'] },
      { cat: 'School', items: ['Real-time daily portal', 'Satisfaction tracking', 'Smart alerts', 'Automated reports'] },
      { cat: 'Director/SB', items: ['Multi-school portfolio', 'Comparisons & benchmarks', 'Policies & standards', 'Escalations & audit trail'] },
    ],
    messaging: 'Unified Internal Messaging',
    messagingText: 'Secure multi-level communication with adaptive hierarchical RBAC and configurable permissions.',
    s5: '5. Integrated Intellectual Property',
    s5intro: "EcoLunch is built on a sector-critical operational platform, integrated, systemic and transversal intellectual property, developed entirely in-house and 100% owned by the company.",
    piVal: 'IP Valuation',
    reconCost: 'Reconstruction cost', defValue: 'Defensible market value',
    piComponents: 'Components — EcoTechSystem',
    module: 'Module', description: 'Description', time: 'Time', cost: 'Cost',
    infraNote: 'Infrastructure, security, DevOps, QA, documentation',
    s6: '6. Payments, Security & Architecture',
    payStruct: 'Payment Structure',
    source: 'Source',
    secTitle: 'Security',
    secItems: ['Isolated multi-tenant (RBAC)', 'End-to-end encryption', 'WAF/DDoS protection', 'LPRPDE/PIPEDA & Bill 25 compliance', 'Data hosted in Quebec'],
    s7: '7. Execution Plan',
    period: 'Period', objective: 'Objective',
    s8: '8. Go-to-Market (GTM)',
    catalyst: 'Catalyst: CSS & School Board Network',
    catalystText: "Direct access to 61 Quebec CSS + 380 Canadian districts. Signing a single institutional entity gives access to multiple schools simultaneously.",
    ratioTitle: 'Evolving Schools/Caterer Ratio',
    phase: 'Phase', catererType: 'Caterer type', ratio: 'Ratio', caterers: 'Caterers',
    acqStrategy: 'Acquisition Strategy',
    acqItems: ['Direct B2B sales via field reps (contractors)', 'Multi-school CSS partnerships', 'Free SaaS for first 22 caterers (launch incentive)', '$50,000 envelope for conversion incentives (migration assistance)'],
    s9: '9. Roadmap & Milestones',
    highlights: 'Key highlights',
    s10: '10. Executive Summary',
    s11: '11. Business Model',
    revStreams: 'Revenue Streams',
    revType: 'Type', revDetail: 'Detail',
    s12: '12. Organization & Costs',
    opex: 'Annual OPEX',
    role: 'Role', y1: 'Y1', y2: 'Y2', y3: 'Y3', y4: 'Y4', y5: 'Y5',
    prelaunch: 'Pre-launch ($250,000)',
    opex6m: 'OPEX pre-launch (6 months x $20,000/month)',
    incentives: 'Caterer conversion incentives',
    reserve: 'Reserve / safety margin',
    totalPrelaunch: 'Total pre-launch',
    s13: '13. Valuation',
    multiples: 'Multiples',
    multiple: 'Multiple', valuation: 'Valuation',
    s14: '14. Investor Summary',
    s15: '15. Financial Projections Y1 (12 months)',
    revLabel: 'Revenue', baiiaLabel: 'EBITDA', margin: 'Margin',
    disclaimer: 'Confidential Document — EcoTech Solutions Inc. — {year}',
  },
};
